import Head from 'next/head';

const PageHeader = () => (
  <Head>
    <title>Goyolo.com | Find Cheap Flight, Bus, Train &amp; Discover New Destinations</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0"
    />

    <meta
      name="description"
      content="Cheap flight, bus, trains, hotels, and car hire with 24/7 customer support &amp; the Goyolo.com Guarantee. Discover a new way of traveling with our interactive map, airport, and destination guides in your pocket."
    />
  </Head>
);
export default PageHeader;
